import { getSubSteps } from '#models/general/steps';

import { getChargingFields } from './charging';
import { getHouseKeepingFields } from './houseKeeping';
import { getTimeRunningFields } from './timeRunning';
import { getTimeOffFields } from './timeOff';
import { getWashIdsFields } from './washIds';
import { getWashScreenSetUpFields } from './washScreenSetUp';

export const WASH_SUBSTEP_TARGET = 'AdelphiWashStepModal';

export const WASH_SUBSTEPS_IDS = {
  WASH_SCREEN_SET_UP: 'washScreenSetUpAdelphi',
  WASH_IDS: 'washIdsAdelphi',
  CHARGING: 'chargingAdelphi',
  TIME_RUNNING: 'timeRunningAdelphi',
  TIME_OFF: 'timeOffAdelphi',
  HOUSE_KEEPING: 'houseCleaningAdelphi'
};

const WASH_NEXT_SUBSTEPS = {
  [WASH_SUBSTEPS_IDS.WASH_SCREEN_SET_UP]: WASH_SUBSTEPS_IDS.WASH_IDS,
  [WASH_SUBSTEPS_IDS.WASH_IDS]: WASH_SUBSTEPS_IDS.CHARGING,
  [WASH_SUBSTEPS_IDS.CHARGING]: WASH_SUBSTEPS_IDS.TIME_RUNNING,
  [WASH_SUBSTEPS_IDS.TIME_RUNNING]: WASH_SUBSTEPS_IDS.TIME_OFF,
  [WASH_SUBSTEPS_IDS.TIME_OFF]: WASH_SUBSTEPS_IDS.HOUSE_KEEPING
};

const WASH_PREVIOUS_SUBSTEPS = {
  [WASH_SUBSTEPS_IDS.WASH_IDS]: WASH_SUBSTEPS_IDS.WASH_SCREEN_SET_UP,
  [WASH_SUBSTEPS_IDS.CHARGING]: WASH_SUBSTEPS_IDS.WASH_IDS,
  [WASH_SUBSTEPS_IDS.TIME_RUNNING]: WASH_SUBSTEPS_IDS.CHARGING,
  [WASH_SUBSTEPS_IDS.TIME_OFF]: WASH_SUBSTEPS_IDS.TIME_RUNNING,
  [WASH_SUBSTEPS_IDS.HOUSE_KEEPING]: WASH_SUBSTEPS_IDS.TIME_OFF
};

export const WASH_SUBSTEPS = getSubSteps(
  WASH_SUBSTEP_TARGET,
  WASH_SUBSTEPS_IDS,
  WASH_NEXT_SUBSTEPS,
  WASH_PREVIOUS_SUBSTEPS
);

export const WASH_COMPLETE_FIELDS = {
  [WASH_SUBSTEPS_IDS.WASH_SCREEN_SET_UP]: getWashScreenSetUpFields,
  [WASH_SUBSTEPS_IDS.WASH_IDS]: getWashIdsFields,
  [WASH_SUBSTEPS_IDS.CHARGING]: getChargingFields,
  [WASH_SUBSTEPS_IDS.TIME_RUNNING]: getTimeRunningFields,
  [WASH_SUBSTEPS_IDS.TIME_OFF]: getTimeOffFields,
  [WASH_SUBSTEPS_IDS.HOUSE_KEEPING]: getHouseKeepingFields
};

export const WASH_SUBSTEPS_ADDITION_PROPS = {
  [WASH_SUBSTEPS_IDS.WASH_SCREEN_SET_UP]: {
    oneColumnForm: true
  },
  [WASH_SUBSTEPS_IDS.WASH_IDS]: {
    oneColumnForm: true
  },
  [WASH_SUBSTEPS_IDS.CHARGING]: {
    oneColumnForm: true
  },
  [WASH_SUBSTEPS_IDS.TIME_RUNNING]: {
    oneColumnForm: true
  },
  [WASH_SUBSTEPS_IDS.TIME_OFF]: {
    oneColumnForm: true
  },
  [WASH_SUBSTEPS_IDS.DIPS]: {
    oneColumnForm: true
  },
  [WASH_SUBSTEPS_IDS.HOUSE_KEEPING]: {
    oneColumnForm: true
  }
};

export const ADELPHI_WASH_SUBSTEPS_INFO = {
  target: WASH_SUBSTEP_TARGET,
  substeps: WASH_SUBSTEPS,
  fields: WASH_COMPLETE_FIELDS,
  additionalProps: WASH_SUBSTEPS_ADDITION_PROPS
};

export const WASH_SCREEN_SET_UP_FIELDS = {
  WASH_RUN_DATE_AND_TIME: 'washRunDateAndTime',
  PERIOD_ID: 'periodId',
  MASH_ID: 'mashingId',
  MASH_COMPLETE_DATE_AND_TIME: 'mashCompleteDateAndTime',
  WASHBACK_NO: 'washbackNo',
  WASHBACK_TEMP: 'washbackTemp',
  WASH_SAMPLE_TEMP: 'washSampleTemp',
  FINAL_GRAVITY: 'finalGravity',
  FERMENTATION_TIME: 'fermentationTime'
};

export const WASH_IDS_FIELDS = {
  WASH_ID: 'washId'
};

export const CHARGING_FIELDS = {
  VOLUME_CHARGED: 'washVolumeCharged',
  VALVES_CLOSED: 'washValvesClosed'
};

export const TIME_RUNNING_FIELDS = {
  DATE_AND_TIME_RUNNING: 'washDateAndTimeRunning'
};

export const TIME_OFF_FIELDS = {
  DATE_AND_TIME_OFF: 'washDateAndTimeOff',
  TEMPERATURE_TIME_OFF: 'washTemperatureTimeOff',
  HYDROMETER_TIME_OFF: 'washHydrometerReadingTimeOff'
};

export const HOUSE_KEEPING_FIELDS = {
  CAUSTIC_CLEANED: 'washCausticCleaned',
  OPERATOR: 'washOperator',
  NOTES: 'washNotes'
};
